import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import {
  FiltersContainer,
  FiltersContainerLeftContainer,
  FiltersContainerRightContainer,
  SelectWrapper,
  MenuWrapper,
  DropdownMenu,
  DropdownItem,
} from "./FiltersContainer.styled";
import { TabSwitcher, Button } from "@ann/web-components";
import PromptShareModal from "../PromptShareModal/PromptShareModal";
import PromptArchiveModal from "../PromptArchiveModal/PromptArchiveModal";

const FiltersContainerComponent = () => {
  const [selectedTab, setSelectedTab] = useState("prompt");
  const { promptId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [isArchiveModalOpen, setIsArchiveModalOpen] = useState(false);
  const [promptName, setPromptName] = useState(""); 
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  const menuRef = useRef(null);

  useEffect(() => {
    setSelectedTab(
      location.pathname.includes("/versions") ? "versions" : "prompt"
    );
  }, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleTabChange = (tabId) => {
    setSelectedTab(tabId);
    if (tabId === "prompt") {
      navigate(`/v2/pms/config/${promptId}`);
    } else {
      navigate(`/v2/pms/config/${promptId}/versions`);
    }
  };

  const handleActionSelect = (action) => {    
    setIsMenuOpen(false); 
    
    if (action === "share") {
      setIsShareModalOpen(true);
    } else if (action === "archive") {
      setIsArchiveModalOpen(true);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleArchive = () => {
  };

  return (
    <FiltersContainer>
      <FiltersContainerLeftContainer>
        <TabSwitcher
          key={selectedTab}
          defaultSelectedId={selectedTab}
          size="medium"
          onChange={handleTabChange}>
          <TabSwitcher.Button id="prompt" label="Prompt" />
          <TabSwitcher.Button id="versions" label="Versions" />
        </TabSwitcher>
      </FiltersContainerLeftContainer>
      {selectedTab === "prompt" && (
        <FiltersContainerRightContainer>
          <MenuWrapper ref={menuRef}>
            <Button
              size="medium"
              type="secondary"
              label="Actions"
              iconRight="chevronDown"
              onClick={toggleMenu}
            />
            {isMenuOpen && (
              <DropdownMenu>
                <DropdownItem onClick={() => handleActionSelect("archive")}>
                  Archive
                </DropdownItem>
                <DropdownItem onClick={() => handleActionSelect("share")}>
                  Share
                </DropdownItem>
              </DropdownMenu>
            )}
          </MenuWrapper>
        </FiltersContainerRightContainer>
      )}
      {selectedTab === "versions" && (                                                                                                
        <FiltersContainerRightContainer>
          <Button
            size="medium"
            type="secondary"
            label="Restore this version"
            iconLeft="autorenew"
            disabled
          />
        </FiltersContainerRightContainer>
      )}
      
      <PromptShareModal
        isOpen={isShareModalOpen}
        onClose={() => setIsShareModalOpen(false)}
      />
      
      <PromptArchiveModal
        isOpen={isArchiveModalOpen}
        onClose={() => setIsArchiveModalOpen(false)}
        onArchive={handleArchive}
        promptName={promptName || `Prompt ${promptId}`}
      />
    </FiltersContainer>
  );
};

export default FiltersContainerComponent;
